import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

//import 'whatwg-fetch';
//import Promise from 'promise-polyfill'; 

import Lang from './lang/Lang';

const savedLang = localStorage.getItem('currentLang') || 'is';
Lang.setCurrentLang(savedLang);

window.Lang = Lang;
window.l = function(phrase) {
	return Lang.get(phrase);
}

const startApp = () => {
	ReactDOM.render(<App />, document.getElementById('root'));
};

if (window.cordova) {
	document.addEventListener('deviceready', startApp, false);
} else {
	startApp();
}



// WEBPACK FOOTER //
// ./src/index.js